module.exports = __webpack_public_path__ + "static/valhalla-0bef40524d2d01c4cd146acfc19e17cc.jpg";